import React, { useState } from "react";
import { Box } from "../../Libraries/Post/GetAllPostRelatedToScreen/AllPosts/index";
import Zone1img from "../../Assets/svgs/Zone1img.svg";

export default function SelectedLayout({ layout, onZoneChange }) {

  const selectedLayout = Number(layout);

  // SELECTED ZONE STATE
  const [selectedZone, setSelectedZone] = useState(null);

  const zoneSelection = (zone) => {
    setSelectedZone(zone);
    onZoneChange(zone);
  };

  // COMMON STYLE
  const getZoneStyle = (zone, extraStyles = {}) => ({
    cursor: "pointer",
    border:
      selectedZone === zone
        ? "1px solid #1A75E8"
        : "1px solid transparent",

    "&:hover": {
      border: "1px solid #1A75E8",
    },

    transition: "0.2s ease",
    ...extraStyles,
  });

  if (!selectedLayout) return null;

  return (
    <Box className="zonesection">

      {/* ---------------- Layout 1 ---------------- */}
      {selectedLayout === 1 && (
        <Box
          onClick={() => zoneSelection(1)}
          sx={getZoneStyle(1, {
            height: "130px",
            background: "#FFFFFF",
            borderRadius: "16px",
          })}
          className="flex flex-column justify-content-center align-items-center gap-3"
        >
          <img src={Zone1img} width="25%" />
          <span className="fs-10">Zone-I (Main Zone)</span>
        </Box>
      )}

      {/* ---------------- Layout 2 ---------------- */}
      {selectedLayout === 2 && (
        <>
          <Box
            onClick={() => zoneSelection(1)}
            sx={getZoneStyle(1, {
              height: "130px",
              background: "#FFFFFF",
              borderRadius: "16px 16px 0 0",
            })}
            className="flex flex-column justify-content-center align-items-center gap-3"
          >
            <img src={Zone1img} width="25%" />
            <span className="fs-10">Zone-1 (Main Zone)</span>
          </Box>

          <Box
            onClick={() => zoneSelection(2)}
            sx={getZoneStyle(2, {
              height: "30px",
              background: "#F6F9FF",
              borderRadius: "0 0 16px 16px",
            })}
            className="flex justify-content-center align-items-center"
          >
            <span className="fs-10">Zone-2 (Footer Zone)</span>
          </Box>
        </>
      )}

      {/* ---------------- Layout 3 / 5 ---------------- */}
      {(selectedLayout === 3 || selectedLayout === 5) && (
        <Box className="flex py-2 px-2">

          <Box
            onClick={() => zoneSelection(1)}
            sx={getZoneStyle(1, {
              width: "75%",
              height: "130px",
              background: "#FFFFFF",
              borderRadius: "16px 0 0 16px",
            })}
            className="flex flex-column justify-content-center align-items-center gap-3"
          >
            <img src={Zone1img} width="25%" />
            <span className="fs-10">Zone-I (Main Zone)</span>
          </Box>

          <Box
            onClick={() => zoneSelection(3)}
            sx={getZoneStyle(3, {
              width: "25%",
              height: "130px",
              background: "#E5F1FD",
              borderRadius: "0 16px 16px 0",
            })}
            className="flex justify-content-center align-items-center"
          >
            <span className="fs-10 text-center">
              Zone-3 (Side Bar)
            </span>
          </Box>

        </Box>
      )}

      {/* ---------------- Layout 4 / 6 ---------------- */}
      {(selectedLayout === 4 || selectedLayout === 6) && (
        <>
          <Box className="flex">

            <Box
              onClick={() => zoneSelection(1)}
              sx={getZoneStyle(1, {
                width: "75%",
                height: "130px",
                background: "#FFFFFF",
                borderRadius: "16px 0 0 0",
              })}
              className="flex flex-column justify-content-center align-items-center gap-3"
            >
              <img src={Zone1img} width="25%" />
              <span className="fs-10">Zone-1 (Main Zone)</span>
            </Box>

            <Box
              onClick={() => zoneSelection(3)}
              sx={getZoneStyle(3, {
                width: "25%",
                height: "130px",
                background: "#E5F1FD",
                borderRadius: "0 16px 0 0",
              })}
              className="flex justify-content-center align-items-center"
            >
              <span className="fs-10">Zone-3</span>
            </Box>

          </Box>

          <Box className="flex">

            <Box
              onClick={() => zoneSelection(2)}
              sx={getZoneStyle(2, {
                width: "75%",
                height: "30px",
                background: "#F6F9FF",
                borderRadius: "0 0 0 16px",
              })}
              className="flex justify-content-center align-items-center"
            >
              <span className="fs-10">Zone-2 (Footer Zone)</span>
            </Box>

            <Box
              onClick={() => zoneSelection(4)}
              sx={getZoneStyle(4, {
                width: "25%",
                height: "30px",
                background: "#A8C5EB",
                borderRadius: "0 0 16px 0",
              })}
              className="flex justify-content-center align-items-center"
            >
              <span className="fs-10">Zone-4</span>
            </Box>

          </Box>
        </>
      )}

    </Box>
  );
}